import KodePelatihanService from "../../services/pelatihan/kode-pelatihan.service";

export const KodePelatihan = {
  data() {
    return {
      optionKodePelatihan : [],
      multi_kode_pelatihan : [],
      items_kode_pelatihan : [],
    };
  },
  methods: {
    getAllKodePelatihan() {
        KodePelatihanService.getKodePelatihanAktif(0,100000,'default')
        .then(response => {
            this.optionKodePelatihan = response.data.data.content
            this.items_kode_pelatihan = response.data.data.content 
        }).catch(error => {
            // comment console console.log(error)
        })
    }
  }
};